import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from 'utils/storeUtils';

export const thunks = {
  addNote: createThunk('notes/addNote', (data) =>
    api.post(WEB_API_ROUTES.notes.info, data)
  ),

  deleteNote: createThunk('notes/addNote', (noteId) =>
    api.delete(WEB_API_ROUTES.notes.delete.replace('{noteId}', noteId))
  ),

  editNote: createThunk('notes/editNote', ({ noteId, data }) =>
    api.put(WEB_API_ROUTES.notes.delete.replace('{noteId}', noteId), data)
  ),
};
